/**
 * Kiti Cymru: PDP main image gallery pagination dots (mobile).
 *
 * Overlays pagination dots on the main product image carousel and
 * keeps them in sync with the visible slide using IntersectionObserver,
 * which is independent of Symmetry's lazy-init timing.
 *
 * Removing the stylesheet + script tags and the .slider-pagination
 * markup in main-product.liquid returns the gallery to stock.
 */
(function () {
  function initPagination(pagination) {
    if (pagination.dataset.dotsInitialised === 'true') return;
    pagination.dataset.dotsInitialised = 'true';

    var carousel = pagination.closest('carousel-slider');
    if (!carousel) return;

    var sliderEl = carousel.querySelector('.slider');
    var slides = carousel.querySelectorAll('.slider__item');
    var dots = pagination.querySelectorAll('.slider-pagination__dot');
    if (!sliderEl || !slides.length || !dots.length) return;

    var activeIndex = -1;

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      for (var i = 0; i < dots.length; i += 1) {
        var isActive = i === index;
        dots[i].classList.toggle('is-active', isActive);
        if (isActive) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // Click a dot -> scroll the slider to that slide.
    pagination.addEventListener('click', function (evt) {
      var dot = evt.target.closest('.slider-pagination__dot');
      if (!dot) return;
      var index = Number(dot.dataset.index);
      if (Number.isNaN(index)) return;

      var target = slides[index];
      if (target) {
        sliderEl.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
      setActive(index);
    });

    // Primary sync: IntersectionObserver on each slide, scoped to the
    // slider viewport. The slide with the highest intersection ratio
    // above the threshold wins.
    if ('IntersectionObserver' in window) {
      var ratios = new Array(slides.length).fill(0);

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var index = Array.prototype.indexOf.call(slides, entry.target);
          if (index < 0) return;
          ratios[index] = entry.intersectionRatio;
        });

        var maxRatio = 0;
        var maxIndex = activeIndex < 0 ? 0 : activeIndex;
        for (var i = 0; i < ratios.length; i += 1) {
          if (ratios[i] > maxRatio) {
            maxRatio = ratios[i];
            maxIndex = i;
          }
        }

        if (maxRatio > 0.55) setActive(maxIndex);
      }, {
        root: sliderEl,
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      for (var i = 0; i < slides.length; i += 1) {
        observer.observe(slides[i]);
      }
    }

    // Fallback sync: passive scroll listener that derives the active
    // index from scrollLeft. Runs in parallel with the observer for
    // robustness on browsers that throttle IO callbacks during scroll.
    var scrollTO;
    sliderEl.addEventListener('scroll', function () {
      clearTimeout(scrollTO);
      scrollTO = setTimeout(function () {
        var first = slides[0];
        if (!first) return;
        var slideWidth = first.getBoundingClientRect().width;
        if (!slideWidth) return;
        var rawIndex = Math.round(sliderEl.scrollLeft / slideWidth);
        var index = Math.max(0, Math.min(rawIndex, slides.length - 1));
        setActive(index);
      }, 50);
    }, { passive: true });

    // Initial active state (first slide, or whatever the theme marked).
    var initialActiveDot = pagination.querySelector('.slider-pagination__dot.is-active');
    if (initialActiveDot) {
      var initialIndex = Number(initialActiveDot.dataset.index);
      if (!Number.isNaN(initialIndex)) activeIndex = initialIndex;
    } else {
      setActive(0);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.slider-pagination--dots').forEach(initPagination);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
